import { useMutation } from "@tanstack/react-query";
import axios from "axios";

import useLocalStorageToken from "../Admin/Shared/Helpers/axios/useLocalStorageToken";

import { api_url } from "@/constants/base_url";
import { useSelector } from 'react-redux';

export const useMutate = () => {
 const lang = useSelector((state) => state?.global?.lang);
  const token = useLocalStorageToken();
  const mutation = useMutation({
    mutationFn: async ({ url, body, method, lang }) => {
      try {
        const response = await axios({
          method,
          url: api_url + url,
          data: body,
          headers: {
            Authorization: `Bearer ${token?.token}`,
            lang: lang,
            "Content-Type": "multipart/form-data",
          },
        });

        return response.data;
      } catch (error) {
        console.log(error);
        throw new Error(error.response.data || "An error occurred");
      }
    },
  });

  return {
    ...mutation,
  };
};
